import React from "react";

import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";

function BalIncarceration() {
  return (
    <div className="py-5">
      <h2 className="text-h-black">Stories of Incarceration</h2>
      <div className="voice-sect">
        <div className="voice-sect-style">
          <p className="text-p-orange">Into the Void</p>
          <p>
            Feroze offered insight into Balochistan’s prison conditions. Most
            telling are his words on the emotional emptiness in jails, which are
            symbolically representative of the lack of facilities in Balochistan
            prisons and point to how disenfranchisement shapes carceral
            experiences in the province.
          </p>
          <div className="my-5">
            <AudioPlayer
              // style={{ width: "300px" }}
              style={{ borderRadius: "1rem" }}
              className="bg-none"
              // autoPlay
              // layout="horizontal"
              src={require("../../assets/audio/FEROZE.wav")}
              //   onPlay={(e) => console.log("onPlay")}
              showSkipControls={true}
              showJumpControls={false}
              // other props here
            />
          </div>
        </div>
        <div className="voice-sect-style">
          <p className="text-p-orange">Courting Crime Out of Desperation</p>
          <p>
            Qadir, the sole earner for his family living in a wooden shack, fits
            the profile of an impoverished prisoner. Lack of education and
            employment drove him to a life of crime. In his story, we hear of
            hopelessness from both outside and behind bars – another framework
            for understanding Balochistan.
          </p>
          <div className="my-5">
            <AudioPlayer
              // style={{ width: "300px" }}
              style={{ borderRadius: "1rem" }}
              className="bg-none"
              // autoPlay
              // layout="horizontal"
              src={require("../../assets/audio/QADIR.wav")}
              //   onPlay={(e) => console.log("onPlay")}
              showSkipControls={true}
              showJumpControls={false}
              // other props here
            />
          </div>
        </div>
        <div className="voice-sect-style">
          <p className="text-p-orange">A Student Activist Disappears</p>
          <p>
            Nadeem was abducted and detained in secret internment on two
            occasions. Never provided a reason nor formally arrested and
            charged, his story is an example of how the deep state operates
            underneath a stunted civilian infrastructure.
          </p>
          <div className="my-5">
            <AudioPlayer
              // style={{ width: "300px" }}
              style={{ borderRadius: "1rem" }}
              className="bg-none"
              // autoPlay
              // layout="horizontal"
              src={require("../../assets/audio/NADEEM.wav")}
              //   onPlay={(e) => console.log("onPlay")}
              showSkipControls={true}
              showJumpControls={false}
              // other props here
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default BalIncarceration;
